import { Card, CardContent, CardHeader, Dialog, DialogContent, DialogTitle, Skeleton } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import { Commons } from '../../helper/CommonService';
import { API_HOST, FILTER_TYPE, KETERSEDIAAN } from '../../helper/Constant';
import DialogBerkas from '../../components/Dialogs/DialogBerkas';
import Filter from './component/Filter';

const columns = [
  { field: 'no_daftar', headerName: 'No Daftar', width: 100 },
  { field: 'nama', headerName: 'Nama', width: 200 },
  {
    field: 'isFoto', headerName: 'Foto', width: 100,
    valueGetter: (value, row) => {
      return row.isFoto ? KETERSEDIAAN.SUDAH : KETERSEDIAAN.BELUM
    }
  },
  {
    field: 'isSuratKesanggupan', headerName: 'Surat Kesanggupan', width: 100,
    valueGetter: (value, row) => {
      return row.isSuratKesanggupan ? KETERSEDIAAN.SUDAH : KETERSEDIAAN.BELUM
    }
  },
  {
    field: 'isAktaKelahiran', headerName: 'Akta Kelahiran', width: 100,
    valueGetter: (value, row) => {
      return row.isAktaKelahiran ? KETERSEDIAAN.SUDAH : KETERSEDIAAN.BELUM
    }
  },
  {
    field: 'isKartuKeluarga', headerName: 'Kartu Keluarga', width: 100,
    valueGetter: (value, row) => {
      return row.isKartuKeluarga ? KETERSEDIAAN.SUDAH : KETERSEDIAAN.BELUM
    }
  },
  {
    field: 'isBuktiHafalan', headerName: 'Bukti Hafalan', width: 100,
    valueGetter: (value, row) => {
      return row.isBuktiHafalan ? KETERSEDIAAN.SUDAH : KETERSEDIAAN.BELUM
    }
  }];

const paginationModel = { page: 0, pageSize: 100 };

function Berkas() {
  const [loading, setLoading] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [santriBerkas, setSantriBerkas] = useState([]);
  const [selectedRow, setSelectedRow] = useState({});

  const RunFilter = (fieldName, filterValue) => {
    setLoading(true);
    LoadData()
      .then(([resSantriUnverified, resBerkas, resSantri, resDataLain, resAyah, resIbu, resWali]) => {
        let filterSantri = PopulateData(resSantriUnverified, resSantri, resDataLain, resBerkas, resAyah, resIbu, resWali);
        if (fieldName) {
          filterSantri = filterSantri.filter((santri) => {
            if (santri[fieldName] === undefined) {
              return false;
            }
            return (santri[fieldName].toString().toUpperCase().includes(filterValue.toUpperCase()))
          })
        }
        setSantriBerkas(filterSantri);
      }).finally(() => {
        setLoading(false);
      });
  }
  const LoadData = () => {
    return Promise.all([
      Commons.GetData(API_HOST + "/progress", "isBerkas_verified=0", true),
      Commons.GetData(API_HOST + "/berkas", "", true),
      Commons.GetData(API_HOST + "/santri", "", true),
      Commons.GetData(API_HOST + "/datalain", "", true),
      Commons.GetData(API_HOST + "/ayah", "", true),
      Commons.GetData(API_HOST + "/ibu", "", true),
      Commons.GetData(API_HOST + "/wali", "", true)
    ]);

  };

  useEffect(() => {
    setLoading(true);
    LoadData()
      .then(([resSantriUnverified, resBerkas, resSantri, resDataLain, resAyah, resIbu, resWali]) => {
        setSantriBerkas(PopulateData(resSantriUnverified, resSantri, resDataLain, resBerkas, resAyah, resIbu, resWali));
      })
      .catch((errResp) => {
        console.log(errResp);
      })
      .finally(() => {
        setLoading(false);
      })
  }, []);

  const PopulateData = (unverifiedSantris, dataSantri, dataLain, dataBerkas, dataAyah, dataIbu, dataWali) => {
    return unverifiedSantris.map((unverified) => {
      let getSantri = dataSantri.find((santriVal) => santriVal.id === unverified.id);
      let getBerkas = dataBerkas?.find((x) => x.id === unverified.id);
      let getDataLain = dataLain?.find((x) => x.id === unverified.id);
      let getAyah = dataAyah?.find((x) => x.id === unverified.id);
      let getIbu = dataIbu?.find((x) => x.id === unverified.id);
      let getWali = dataWali?.find((x) => x.id === unverified.id);
      let getWaNo = Commons.GetNoWa(getDataLain, getAyah, getIbu, getWali);
      return {
        id: unverified.id,
        nama: getSantri?.nama,
        no_daftar: getSantri?.no_daftar,
        foto_santri: getBerkas?.foto_santri,
        isFoto: (getBerkas && getBerkas.isFoto === KETERSEDIAAN.SUDAH) ? 1 : 0,
        surat_kesanggupan: getBerkas?.surat_kesanggupan,
        isSuratKesanggupan: (getBerkas && getBerkas.isSuratKesanggupan === KETERSEDIAAN.SUDAH) ? 1 : 0,
        akta_kelahiran: getBerkas?.akta_kelahiran,
        isAktaKelahiran: (getBerkas && getBerkas.isAktaKelahiran === KETERSEDIAAN.SUDAH) ? 1 : 0,
        kartu_keluarga: getBerkas?.kartu_keluarga,
        isKartuKeluarga: (getBerkas && getBerkas.isKartuKeluarga === KETERSEDIAAN.SUDAH) ? 1 : 0,
        bukti_hafalan: getBerkas?.bukti_hafalan,
        isBuktiHafalan: (getBerkas && getBerkas.isBuktiHafalan === KETERSEDIAAN.SUDAH) ? 1 : 0,
        waNo: getWaNo
      }
    });
  };

  const ChangeValidasiBerkas = (e, id) => {
    setSantriBerkas((prev) =>
      prev.map((item) =>
        item.id === id ? {
          ...item,
          [e.target.name]: (e.target.checked) ? KETERSEDIAAN.SUDAH : KETERSEDIAAN.BELUM
        } : item
      ));
  }

  const ShowTable = () => {
    if (loading) {
      return (<>
        <Skeleton variant="rectangular" width={"100%"} height={100} />
      </>)
    }
    return (
      <>
        <DataGrid
          rows={santriBerkas}
          columns={columns}
          initialState={{ pagination: { paginationModel } }}
          pageSizeOptions={[5, 10]}
          checkboxSelection
          onRowClick={(e) => {
            setSelectedRow(e.row);
            setDialogOpen(true);
          }}
          disableMultipleRowSelection={true}
          sx={{ border: 0 }}
        />

      </>
    );
  }

  const HandleDialogClose = (e) => {
    setDialogOpen(false);
  }

  return (
    <>
      <DialogBerkas rowDetail={santriBerkas.find((santr) => { return santr.id === selectedRow.id })} handleChangeData={ChangeValidasiBerkas} isOpen={dialogOpen} handleClose={HandleDialogClose}></DialogBerkas>
      <Card>
        <CardHeader title="Berkas Management" sx={{ borderBottom: "1px solid #f4f4f4" }}>
        </CardHeader>
        <CardContent>
          <Filter RunFilter={RunFilter} FilterTypeBelum={FILTER_TYPE.BERKAS_BELUM} FilterTypeSudah={FILTER_TYPE.BERKAS_SUDAH}></Filter>
          {ShowTable()}
        </CardContent>
      </Card>
    </>
  );
}

export default Berkas;